import { useRef, useCallback, useLayoutEffect } from 'react';
import { calculateOverlaps } from './calculate-overlaps';

export const useTooltipCollision = dots => {
  const containerRef = useRef(null);
  const tooltipsRef = useRef({});
  const callbacksRef = useRef({});

  const setTooltipRef = useCallback(id => {
    if (!callbacksRef.current[id]) {
      callbacksRef.current[id] = el => {
        if (el) {
          tooltipsRef.current[id] = el;
        } else {
          delete tooltipsRef.current[id];
        }
      };
    }
    return callbacksRef.current[id];
  }, []);

  useLayoutEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const applyShifts = containerWidth => {
      const activeTooltips = dots.reduce((acc, dot) => {
        const el = tooltipsRef.current[dot.id];

        if (el) {
          acc.push({
            id: dot.id,
            position: dot.position,
            width: el.offsetWidth,
            center: containerWidth * (dot.position / 100),
            el,
          });
        }

        return acc;
      }, []);

      const shifts = calculateOverlaps(activeTooltips, containerWidth);

      activeTooltips.forEach(({ id, el }) => {
        const shiftAmount = shifts[id] || 0;
        el.style.setProperty('--tooltip-shift', `${shiftAmount}px`);
      });
    };

    const observer = new ResizeObserver(entries => {
      if (entries[0]) {
        applyShifts(entries[0].contentRect.width);
      }
    });

    observer.observe(container);

    applyShifts(container.clientWidth);

    // eslint-disable-next-line consistent-return
    return () => observer.disconnect();
  }, [dots]);

  return { containerRef, setTooltipRef };
};
